import { defineComponent as _defineComponent } from 'vue'
import {
  HeaderFilterLoader,
  HeaderSubtitleLoader,
  HeaderTitleLoader,
  DataTableLoader
} from '@/modules/trade/views/TradePositionsView/components/Loaders';

export default /*#__PURE__*/_defineComponent({
  __name: 'TabContentLoader',
  setup(__props) {


return { __sfc: true,HeaderFilterLoader, HeaderSubtitleLoader, HeaderTitleLoader, DataTableLoader }
}

})